import styled from 'styled-components';

export const Container = styled.div``;

export const KeyValue = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;

export const KeyValueItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  padding-bottom: 1rem;
`;

export const MovementHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
`;

export const AttachmentsEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
  flex-shrink: 0;
`;

interface Props {
  color?: 'danger' | 'success' | 'warning' | 'gray';
}
export const Key = styled.h6`
  color: ${({ theme }) => theme.colors?.text.primary};
`;

export const Value = styled.h6<Props>`
  color: ${(props) =>
    props.color
      ? props.theme.colors?.[props.color]
      : props.theme.colors?.text.secondary};
`;

export const DivAnexos = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const H6 = styled.h6``;

export const AttachmentName = styled.h6`
  word-break: break-word;
  text-align: right;
`;
